module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAARNJREFUKFOdkjFOw0AQRf/YEtgVHGU5AU5NEW6AKahSJEg0sQvcWLTkBHAJasINlhvkCE5llGh3mLUJKMk6Rplmpdl9O/P/DOHIIB+nyjoF0c3eHQf3Oj/RLr8H/kAv3kaIBy6vp/F8C/RAnzqLlCq/nqXEGA5kFDqLk1+wo9KCEKbMxoGqBendnQ2oypUCrCRwftCrDciY0b8h+dEYXIUh3sB8K2BdiIOPvVORx+LltXQ1BAcXbUWycwHPumBrMQoId41O52oWUavxqU4a0Z7YhQD+6HN1CUsjcfBhU6n5V4zReTTpmuNSdCQgGQPocqsR0arz+NWzOaI5MJVsx+JvVMaZ4uRUWJ+muqDKu6u9DsuDb2JTciXH8yYNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/5.png
// module id = M8OB
// module chunks = 1